import { cn } from './utils'
import { Progress } from '../components/progress'
import type * as React from 'react'

interface LoadingContentProps {
  loading?: boolean
  /** Constrain spinner height to match content (e.g., icon size) */
  size?: number
  children: React.ReactNode
}

export function LoadingContent({
  loading,
  size,
  children,
}: LoadingContentProps) {
  return (
    <span className="inline-grid w-full [&>*]:[grid-area:1/1]">
      <span
        className={cn(
          'flex w-full items-center justify-center gap-2',
          loading && 'invisible',
        )}
      >
        {children}
      </span>
      {loading && (
        <span
          className="flex items-center justify-center [&_svg]:h-full"
          style={size ? { height: size } : undefined}
        >
          <Progress variant="circular" size="sm" />
        </span>
      )}
    </span>
  )
}
